import React from 'react'
import styles from './Tints.module.css'

const Tints = ({ tints = [] }) => {
  if (tints.length === 0) return null

  return (
    <div className={styles.container}>
      <div className={styles.wrap}>
        {tints.map((tint, index) => (
          <div key={tint?.DetailId} className={styles.tint}>
            <div
              className={styles.color}
              style={{ backgroundColor: tint.Color }}
            />
            <span className={styles.label}>
              {tint.Name} {tint.Code}
            </span>

            {index < tints.length - 1 && (
              <span className={styles.separator}>, </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Tints
